<script lang="ts" setup>
  import { BaseInput } from '@qic/ui-components'
  import { computed } from 'vue'
  import { EMAIL_MASK, EMAIL_MAX_LENGTH } from './BaseEmailInput.constants'

  interface Props {
    modelValue: string
    errors?: string[]
  }
  interface Emits {
    (e: 'update:modelValue', promocode: string): void
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: '',
  })

  const emit = defineEmits<Emits>()

  const value = computed({
    get: () => props.modelValue,
    set: (value) => {
      emit('update:modelValue', value)
    },
  })
</script>

<template>
  <BaseInput
    v-model="value"
    :errors="errors"
    v-bind="$attrs"
    num-rtl
    :mask="'#'.repeat(EMAIL_MAX_LENGTH)"
    :mask-tokens="{ '#': { pattern: EMAIL_MASK } }"
    :label="$t('outbound.travelers.email')"
    input-mode="email"
  />
</template>
